module.exports = __webpack_public_path__ + "img/b7-2.2b978cb.png";